export default __webpack_public_path__ + "static/media/Front-City-Center-Iraq.f426deae.jpg";